angular.module('bb.assets').config(assetsRoutes);

assetsRoutes.$inject = ['$routeProvider'];
function assetsRoutes($routeProvider) {
  $routeProvider.when('/assets/', {
    template: '<bb-assets-list />',
    reloadOnSearch: false,
  });
}

export {};
